import styled from '@emotion/styled'

export const HeaderTitleContainer = styled.h2`
  z-index: 20;
  position: relative;
  bottom: 1px;

  margin: 0;
  justify-self: center;

  font-size: 24px;
  line-height: 30px;
  font-weight: 600;
  letter-spacing: 1.8px;

  opacity: 0.6;
`
